import AjaxUtils from './ajaxUtils';

const editContactData = async ({
  contactId,
  jobTitle,
  emails,
  phones,
  emailsMetadata,
  phonesMetadata,
  company,
  metadata,
}) => {
  const route = '/v4/edit-contacts';
  const body = {
    contactId,
    jobTitle,
    emails,
    phones,
    emailsMetadata,
    phonesMetadata,
    company,
    metadata,
  };

  return AjaxUtils.post(route, body);
};

export {
  editContactData,
};
